import { Component, OnDestroy, OnInit, Type } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';

import { BaseEntity } from '../models';
import { BaseService } from '../services';
import { AlertUtils, ParamUtils, scrollToTop } from '../shared';
import { HTTP_ERROR_OCCURRED } from '../shared/constants';

@Component({
    selector: 'qms-popup',
    template: ''
})
export class PopupComponent<Model extends BaseEntity, ModelService extends BaseService<Model>>
    implements OnInit, OnDestroy {

    private modalRef: NgbModalRef;
    protected redirectUrl: string;

    protected routeParamsSubscription: Subscription;
    protected routeDataSubscription: Subscription;
    protected routeQueryParamsSubscription: Subscription;
    protected errorSubscription: Subscription;

    constructor(private router: Router,
                protected route: ActivatedRoute,
                private modalService: NgbModal,
                protected eventManager: JhiEventManager,
                protected alertService: JhiAlertService,
                protected modelService: ModelService) {
    }

    ngOnInit() {
        this.routeParamsSubscription = this.route.params.subscribe((params) => {

            const handleMissingRoute = () => {
                AlertUtils.notifyNotFound(this.eventManager, this.alertService);
                this.closeModal(true);
            };

            let modelId: string | number;
            ParamUtils.parseNumber(params['id'], (id: number) => {
                modelId = id;
            }, () => {
                handleMissingRoute();
            }, (notNumberParam: any) => {
                ParamUtils.parseString(params['id'], (id: string) => {
                    modelId = id;
                }, () => {
                    handleMissingRoute();
                });
            });

            this.routeDataSubscription = this.route.data.subscribe((data) => {
                this.errorSubscription = this.eventManager.subscribe(HTTP_ERROR_OCCURRED, () => {
                    this.closeModal(true);
                    scrollToTop();
                });

                const modalComponent = data['modalComponent'];
                this.modelService.find(modelId).subscribe((model) => {
                    this.errorSubscription.unsubscribe(); // Modal popup has own error handling
                    this.openModal(modalComponent, model);
                });
            });
        });

        this.routeQueryParamsSubscription = this.route.queryParams.subscribe((params) => {
            this.redirectUrl = params['redirectUrl'];
        });
    }

    ngOnDestroy() {
        if (this.routeParamsSubscription) {
            this.routeParamsSubscription.unsubscribe();
        }
        if (this.routeDataSubscription) {
            this.routeDataSubscription.unsubscribe();
        }
        if (this.errorSubscription) {
            this.errorSubscription.unsubscribe();
        }
    }

    protected openModal(component: Component, model: Model) {
        this.modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        this.modalRef.componentInstance.model = model;
        this.modalRef.result.then((result) => {
            this.closeModal(false);
        }, (reason) => {
            this.closeModal(true);
        });
    }

    protected closeModal(isCanceled: boolean) {
        if (!isCanceled && this.redirectUrl && this.redirectUrl !== '') {
            this.router.navigateByUrl(this.redirectUrl, { replaceUrl: true });
        } else {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/popup-component.ts